export default __webpack_public_path__ + "static/media/about-gallery1.65f22207.jpg";